"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputStyled = exports.InputContainerStyled = exports.MsgContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var styled_components_2 = require("styled-components");
var themes_1 = require("../../themes");
var mixins_1 = require("../../themes/mixins");
var globalVariables_1 = require("../../globalStyles/globalVariables");
var greyColor10 = themes_1.colors.greyColor10, greyColor70 = themes_1.colors.greyColor70, greyColor5 = themes_1.colors.greyColor5, greyColor15 = themes_1.colors.greyColor15, greyColor80 = themes_1.colors.greyColor80, greyColor40 = themes_1.colors.greyColor40, greyColor100 = themes_1.colors.greyColor100, white = themes_1.colors.white, red = themes_1.colors.red, green = themes_1.colors.green, invertRed = themes_1.colors.invertRed, invertGreen = themes_1.colors.invertGreen;
var SIZES = {
    S: "3rem",
    M: "4rem",
};
var getColorValue = function (status, invert) {
    switch (status) {
        case 'error':
            return invert ? invertRed : red;
        case 'success':
            return invert ? invertGreen : green;
    }
};
exports.MsgContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 0.5rem;\n  ", "\n"], ["\n  margin-top: 0.5rem;\n  ", "\n"])), function (_a) {
    var status = _a.status, invert = _a.invert;
    return status && (0, styled_components_2.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), getColorValue(status, invert));
});
exports.InputContainerStyled = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n  ", ";\n\n  position: relative;\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  ", "\n\n  ", "\n  ", "\n\n  ", ";\n  ", ";\n  ", "\n"], ["\n  ", "\n  ", ";\n\n  position: relative;\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  ", "\n\n  ", "\n  ", "\n\n  ", ";\n  ", ";\n  ", "\n"
    // export const DisplayOnlyComp = styled.div`
    // ${({ size }) =>
    //     css`
    //       height: ${SIZES[size]};
    //     `}
    // `
])), function (_a) {
    var composition = _a.composition;
    switch (composition) {
        case 'icon+text':
            return (0, styled_components_2.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          padding: 0 2rem 0 1.5rem;\n        "], ["\n          padding: 0 2rem 0 1.5rem;\n        "])));
        default:
            return (0, styled_components_2.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), globalVariables_1.globalInputElemPadding);
    }
}, function (_a) {
    var eyeIcon = _a.eyeIcon;
    return eyeIcon && (0, styled_components_2.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      flex-direction: row-reverse;\n    "], ["\n      flex-direction: row-reverse;\n    "])));
}, function (_a) {
    var invert = _a.invert;
    return (invert ? greyColor80 : greyColor5);
}, function (_a) {
    var invert = _a.invert;
    return (invert ? white : greyColor100);
}, (0, mixins_1.transition)('background-color'), globalVariables_1.globalInputElemHover, globalVariables_1.globalInputElemFocused, function (_a) {
    var disabled = _a.disabled;
    return disabled && (0, styled_components_2.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      background-color: ", ";\n      pointer-events: none;\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      pointer-events: none;\n      color: ", ";\n    "])), greyColor15, greyColor40);
}, function (_a) {
    var readOnly = _a.readOnly;
    return readOnly && (0, styled_components_2.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      pointer-events: none;\n    "], ["\n      pointer-events: none;\n    "])));
}, function (_a) {
    var status = _a.status, invert = _a.invert;
    return status && (0, styled_components_2.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n     ::after{\n         content: none;\n        }\n        box-shadow: inset 0px -2px 0px ", ";;\n     }\n    "], ["\n     ::after{\n         content: none;\n        }\n        box-shadow: inset 0px -2px 0px ", ";;\n     }\n    "])), getColorValue(status, invert));
});
// export const DisplayOnlyComp = styled.div`
// ${({ size }) =>
//     css`
//       height: ${SIZES[size]};
//     `}
// `
exports.InputStyled = styled_components_1.default.input(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", "\n  border: none;\n  outline: none;\n  flex-grow: 1;\n  background: transparent;\n  color: inherit;\n\n  &:-webkit-autofill {\n    transition-delay: 9999s;\n  }\n\n  ::placeholder {\n    color: ", ";\n  }\n"], ["\n  ", "\n  border: none;\n  outline: none;\n  flex-grow: 1;\n  background: transparent;\n  color: inherit;\n\n  &:-webkit-autofill {\n    transition-delay: 9999s;\n  }\n\n  ::placeholder {\n    color: ", ";\n  }\n"])), function (_a) {
    var size = _a.size;
    return (0, styled_components_2.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      height: ", ";\n    "], ["\n      height: ", ";\n    "])), SIZES[size]);
}, greyColor40);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
